"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ModalAlert_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlert"));
var ConnectionSuccessMsg_1 = __importDefault(require("./ConnectionSuccessMsg"));
var ConnectionSuccess = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    return ((0, jsx_runtime_1.jsx)(ModalAlert_1.default, { open: open, onClose: function () { onClose(); }, status: "success", title: "Connection Success", description: (0, jsx_runtime_1.jsx)(ConnectionSuccessMsg_1.default, {}), buttonText: "Excellent", buttonAction: function () { onClose(); } }));
};
exports.default = ConnectionSuccess;
